import axios from 'axios';
import { normalizeGetTableQuery } from '@/utils/globalHelpers';

export class CustomerService {
  getCustomersSmall() {
    return fetch('/demo/data/customers-small.json', { headers: { 'Cache-Control': 'no-cache' } })
      .then((res) => res.json())
      .then((d) => d.data);
  }
  getCustomersMedium() {
    return fetch('/demo/data/customers-medium.json', { headers: { 'Cache-Control': 'no-cache' } })
      .then((res) => res.json())
      .then((d) => d.data);
  }

  getCustomersLarge() {
    return fetch('/demo/data/customers-large.json', { headers: { 'Cache-Control': 'no-cache' } })
      .then((res) => res.json())
      .then((d) => d.data);
  }
  async createCustomerAddress(data) {
    return await axios.post('/api/v1/portal/customerAddress', data);
  }
  async editCustomerAddress(id, data) {
    return await axios.put(`api/v1/portal/customerAddress/${id}`, data);
  }
  async getCustomers(params) {
    return await axios.get(`api/v1/portal/customer`, { params: normalizeGetTableQuery(params) });
  }
  async getCustomerSalesPersons(customerId, params) {
    return await axios.get(`api/v1/portal/userCustomer?customer_id=${customerId}`, {
      params: normalizeGetTableQuery(params)
    });
  }
  async getCustomerAddresses(params, customerId) {
    const tableParam = normalizeGetTableQuery(params);
    tableParam.customer_id = customerId;
    return await axios.get(`api/v1/portal/customerAddress`, { params: tableParam });
  }
  async createCustomer(data) {
    return await axios.post(`api/v1/portal/customer`, data);
  }

  async getCustomerById(customerId) {
    this._customerId = customerId;
    return await axios.get(`/api/v1/portal/customer/${customerId}`);
  }

  async updateCustomer(id, data) {
    return await axios.put(`api/v1/portal/customer/${id}`, data);
  }
  async getCustomerContacts(params, customerId) {
    const tableParam = normalizeGetTableQuery(params);
    tableParam.customer_id = customerId;

    return await axios.get(`api/v1/portal/customerContact`, { params: tableParam });
  }
  async createCustomerContact(data) {
    return await axios.post(`api/v1/portal/customerContact`, data);
  }
  async updateCustomerContact(id, data) {
    return await axios.put(`api/v1/portal/customerContact/${id}`, data);
  }
  async createSalesPerson(data) {
    return await axios.post(`api/v1/portal/userCustomer`, data);
  }
  async updateSalesPerson(id, data) {
    return await axios.put(`api/v1/portal/userCustomer/${id}`, data);
  }
  async getCustomerLeads(params, customerId) {
    const tableParam = normalizeGetTableQuery(params);
    return await axios.get(`api/v1/portal/lead?customer_id${customerId}`, { params: tableParam });
  }
  async createCustomerLead(data) {
    return await axios.post(`api/v1/portal/lead`, data);
  }
  async updateCustomerLead(id, data) {
    return await axios.put(`api/v1/portal/lead/${id}`, data);
  }
}
